// extracted by mini-css-extract-plugin
export default {"Patch":"SurveyPatch_Patch__Bb6zw"};